export default "__VITE_ASSET__332437f6__"